import * as Yup from 'yup';

export const createProgramListFormValidationSchema = Yup.object().shape({
  programName: Yup.string().required('Please enter program name'),
  organisationName: Yup.string().optional(),
  link: Yup.string().required('Please enter program link'),
  description: Yup.string().optional(),
  endDate: Yup.string().optional(),
  industry: Yup.array().of(Yup.string()).optional(),
  programType: Yup.array().of(Yup.string()).optional(),

  banner: Yup.object()
    .shape({
      url: Yup.string().optional()
      // height: Yup.number().positive('Height must be a positive number').optional(),
      // width: Yup.number().positive('Width must be a positive number').optional()
    })
    .optional()
});

export default createProgramListFormValidationSchema;
